export default {
	name: 'application-management',
	path: '/application-management',
	redirect: '/application-management/application-market',
	meta: {
		title: '应用管理',
		icon: 'icon-application-management'
	},
	children: [
		{
			name: 'application-market',
			path: 'application-market',
			fullPath: '/application-management/application-market',
			meta: {
				title: '应用市场',
				icon: 'icon-market'
			},
			component: () =>
				import(/* webpackChunkName: "application-market" */ '@/views/application-management/application-market')
		},
		{
			name: 'application-creating',
			path: 'application-creating',
			fullPath: '/application-management/application-market/creating',
			meta: {
				title: '创建应用'
			},
			component: () =>
				import(/* webpackChunkName: "application-creating" */ '@/views/application-management/application-market/creating')
		},
		{
			name: 'channel-configuration',
			path: 'channel-configuration',
			fullPath: '/application-management/channel-configuration',
			meta: {
				title: '渠道应用配置',
				icon: 'icon-channel-configuration'
			},
			component: () =>
				import(/* webpackChunkName: "channel-configuration" */ '@/views/application-management/channel-configuration')
		},
		{
			name: 'school-configuration',
			path: 'school-configuration',
			fullPath: '/application-management/school-configuration',
			meta: {
				title: '学校移动端配置',
				icon: 'icon-school-configuration'
			},
			component: () =>
				import(/* webpackChunkName: "school-configuration" */ '@/views/application-management/school-configuration')
		},
		{
			name: 'menu-customization',
			path: '/application-management/menu-customization',
			meta: {
				title: 'web菜单自定义配置'
			},
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/application-management/menu-customization')
		}
	]
};
